import React, { useState, useEffect } from 'react';
import ModalContract from './ModalContract';
import { Solicitud } from './Solicitud';

const Header = () => {
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  // Altura real del navbar con el padding
  const navbarHeight = 70; // 40px de altura del logo + 15px padding arriba + 15px padding abajo

  // Verificar el tamaño de la pantalla y ajustar el main-section
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setMenuOpen(false);
      }
    };

    // Ajustar el margin-top de la sección principal
    const adjustMainSection = () => {
      const mainSection = document.querySelector('.main-section');
      if (mainSection) {
        mainSection.style.marginTop = `${navbarHeight}px`;
      }
    };

    checkMobile();
    adjustMainSection();
    
    window.addEventListener('resize', () => {
      checkMobile();
      adjustMainSection();
    });
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // Función para alternar el menú
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Función para cerrar el menú
  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Abrir modal y cerrar menú
  const openModalAndCloseMenu = () => {
    setShowSignatureModal(true);
    closeMenu();
  };

  return (
    <header style={{
      width: '100%',
      position: 'relative'
    }}>
      <nav style={{
        background: '#0052d9',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.5)',
        padding: '15px 0',
        height: 'auto'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          padding: '10px',
        }}>
          {/* Logo - más cerca de la esquina izquierda */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            height: '40px',
            marginLeft: isMobile ? '15px' : '100px'
          }}>
            <a href="https://amsm.cl" style={{
              display: 'block',
              height: '100%'
            }}>
              <img 
                src="https://noticias.amsm.cl/img/logoblanco.png" 
                alt="AMSM Logo" 
                style={{
                  height: '100%',
                  display: 'block'
                }} 
              />
            </a>
          </div>
          
          {/* Botón hamburguesa para móvil */}
          <button 
            style={{
              display: isMobile ? 'flex' : 'none',
              flexDirection: 'column',
              justifyContent: 'space-between',
              width: '30px',
              height: '21px',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '0',
              zIndex: 10,
              marginRight: '25px'
            }}
            onClick={toggleMenu}
            aria-label="Menú"
          >
            <span style={{
              display: 'block',
              height: '3px',
              width: '100%',
              borderRadius: '3px',
              backgroundColor: '#fff'
            }}></span>
            <span style={{
              display: 'block',
              height: '3px',
              width: '100%',
              borderRadius: '3px',
              backgroundColor: '#fff'
            }}></span>
            <span style={{
              display: 'block',
              height: '3px',
              width: '100%',
              borderRadius: '3px',
              backgroundColor: '#fff'
            }}></span>
          </button>
          
          {/* Menú de navegación - más cerca de la esquina derecha */}
          <div style={{
            display: isMobile ? (menuOpen ? 'block' : 'none') : 'block',
            position: isMobile ? 'absolute' : 'static',
            top: isMobile ? '70px' : 'auto',
            left: isMobile ? 0 : 'auto',
            right: isMobile ? 0 : 'auto',
            backgroundColor: isMobile ? '#0052d9' : 'transparent',
            boxShadow: isMobile ? '0 4px 6px rgba(0,0,0,0.1)' : 'none',
            padding: isMobile ? '10px 0' : 0,
            zIndex: 1000,
            marginRight: isMobile ?  0 : '100px',
          }}>
            <ul style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              listStyle: 'none',
              margin: 0,
              padding: 0,
              justifyContent: 'flex-end'
            }}>
              <li style={{
                margin: isMobile ? '10px 0' : '0 10px'
              }}>
                <a 
                  href="#nosotros" 
                  style={{
                    color: '#fff',
                    textDecoration: 'none',
                    fontSize: '18px',
                    fontWeight: '500',
                    padding: isMobile ? '8px 20px' : '8px 0',
                    display: 'block',
                    textAlign: isMobile ? 'center' : 'right'
                  }}
                  onClick={closeMenu}
                >
                  Nosotros
                </a>
              </li>
              <li style={{
                margin: isMobile ? '10px 0' : '0 10px'
              }}>
                <a 
                  href="#beneficios" 
                  style={{
                    color: '#fff',
                    textDecoration: 'none',
                    fontSize: '18px',
                    fontWeight: '500',
                    padding: isMobile ? '8px 20px' : '8px 0',
                    display: 'block',
                    textAlign: isMobile ? 'center' : 'right'
                  }}
                  onClick={closeMenu}
                >
                  Beneficios
                </a>
              </li>
              <li style={{
                margin: isMobile ? '10px 0' : '0 10px'
              }}>
                <a 
                  href="#contacto" 
                  style={{
                    color: '#fff',
                    textDecoration: 'none',
                    fontSize: '18px',
                    fontWeight: '500',
                    padding: isMobile ? '8px 20px' : '8px 0',
                    display: 'block',
                    textAlign: isMobile ? 'center' : 'right'
                  }}
                  onClick={closeMenu}
                >
                  Contacto
                </a>
              </li>
              <li style={{
                margin: isMobile ? '10px 0' : '0 0 0 10px'
              }}>
                <a 
                  href="#" 
                  style={{
                    color: '#fff',
                    textDecoration: 'none',
                    fontSize: '18px',
                    fontWeight: '500',
                    padding: isMobile ? '8px 20px' : '8px 0',
                    display: 'block',
                    textAlign: isMobile ? 'center' : 'right'
                  }}
                  onClick={openModalAndCloseMenu}
                >
                  Solicitudes
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      
      {/* No necesitamos este div espaciador si estamos ajustando directamente el margin-top de main-section */}
      {/* <div style={{ height: '70px' }}></div> */}
      
      <ModalContract showSignatureModal={showSignatureModal} setShowSignatureModal={setShowSignatureModal}>
        <Solicitud />
      </ModalContract>
    </header>
  );
}

export default Header;